var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 410,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-817 -1208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.957 208.16 434.957 267.319 424.759 274.662 424.759 214.739 414.557 210.352 414.557 282.003 404.999 288.888 404.359 289.347 404.359 205.992 394.159 201.608 394.159 553.029 383.961 553.029 383.961 197.248 373.762 192.86 373.762 553.029 363.562 553.029 363.562 177.564 373.762 181.924 383.961 186.308 394.159 190.668 404.359 195.056 414.557 199.416 424.759 203.8 434.957 208.16",
    fill: "#0CC0DF",
    transform: "matrix(1.00167 0 0 1 599.373 1030.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.562 177.564 363.562 553.029 346.299 553.029 346.299 353.988 343.112 351.72 338.955 348.709 330.592 342.692 322.253 336.672 321.055 335.807 321.055 208.16 363.562 177.564",
    fill: "#333333",
    transform: "matrix(1.00167 0 0 1 599.373 1030.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.962 295.112 502.962 553.029 494.574 553.029 494.574 300.516 486.208 296.894 486.208 553.029 477.82 553.029 477.82 293.326 469.459 289.73 469.459 553.029 461.093 553.029 461.093 286.135 452.705 282.538 452.705 553.029 444.339 553.029 444.339 269.996 452.705 273.566 461.093 277.161 469.459 280.756 477.82 284.348 486.208 287.92 494.574 291.517 502.962 295.112",
    fill: "#0CC0DF",
    transform: "matrix(1.00167 0 0 1 599.373 1030.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.339 269.996 444.339 553.029 409.459 553.029 409.459 295.112 414.557 291.44 424.759 284.095 434.957 276.751 444.339 269.996",
    fill: "#333333",
    transform: "matrix(1.00167 0 0 1 599.373 1030.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.065 337.337 310.065 553.029 303.207 553.029 303.207 347.638 296.373 350.572 296.373 553.029 289.514 553.029 289.514 353.502 282.655 356.462 282.655 553.029 275.795 553.029 275.795 359.392 268.937 362.325 268.937 553.029 262.077 553.029 262.077 357.916 268.937 354.981 275.795 352.025 282.655 349.091 289.514 346.157 296.373 343.227 303.207 340.267 310.065 337.337",
    fill: "#333333",
    transform: "matrix(1.00167 0 0 1 599.373 1030.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65 357.916 338.65 553.029 310.091 553.029 310.091 337.359 317.766 342.895 321.055 345.242 326.129 348.888 334.468 354.905 338.65 357.916",
    fill: "#0CC0DF",
    transform: "matrix(1.00167 0 0 1 599.373 1030.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.626 587.45 227.388 587.45C220.403 587.45 217.276 578.691 222.682 574.266L246.586 554.708C247.914 553.622 249.577 553.029 251.292 553.029L513.722 553.029C515.436 553.029 517.1 553.622 518.427 554.708L542.329 574.266C547.738 578.691 544.609 587.45 537.626 587.45",
    fill: "#0CC0DF",
    transform: "matrix(1.00167 0 0 1 599.373 1030.49)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.5f524af0e39070509de06c020ae17deb.svg";
export { ForwardRef as ReactComponent };